import { doGet2, doPost2WithFormData } from './common'

/*
  getImageEnhancementStatus: returns how many generations the user has left for this step,
  without generating. Used to show the limit state before the user uploads a photo.

  @returns {Promise<Response>} the raw fetch Response ({ remainingGenerations })
*/
export const getImageEnhancementStatus = ({ stepId, stepConfigId }) => {
  return doGet2('/image-enhancement/status', { stepId, stepConfigId })
}

/*
  serializeInputValues: turns the step's `values` map into the wire format the API expects -
  a plain map of input key -> string.

  A CHECKLIST input holds an array of the option values the user ticked, and the endpoint
  takes strings, so the array is joined with commas and no space ("dragon,rose,silver").
  Option values are slugs and never contain a comma, so the API can split it back apart.
  This lives in the service because the shape of the request is the service's contract:
  every caller of generateImage gets it, and a non-array value is passed through untouched.
*/
export const serializeInputValues = (inputs = {}) =>
  Object.fromEntries(
    Object.entries(inputs || {}).map(([key, value]) => [
      key,
      Array.isArray(value) ? value.join(',') : value,
    ]),
  )

/*
  generateImage: uploads the user's photo plus their input selections and returns the
  AI-generated image. The base prompt + reference images are resolved server-side from the
  step config (stepConfigId), so the client only sends the photo and the chosen input values.

  @param {Object} args
  @param {string} args.breakId
  @param {string} args.stepId        - the break-step id (for analytics / limits)
  @param {string|number} args.stepConfigId - the step-builder record id (locked config source)
  @param {Object} args.inputs        - map of input key -> chosen option value / text,
                                      or an array of values for a CHECKLIST input
  @param {File}   args.file          - the user's photo
  @returns {Promise<Response>} the raw fetch Response
*/
export const generateImage = ({ breakId, stepId, stepConfigId, inputs, file }) => {
  return doPost2WithFormData('/image-enhancement/generate', {
    file,
    breakId,
    stepId,
    stepConfigId,
    inputs: JSON.stringify(serializeInputValues(inputs)),
  })
}
